<template>
  <VAppBar elevation="0" border>
    <VToolbar color="white">
      <template #title>
        <span class="font-weight-bold text-gray-500">
          {{ pageTitle }}
        </span>
      </template>

      <template v-if="pageHasBack" #append>
        <VBtn :ripple="false" @click="onBack">
          <span>{{ $t('words.back') }}</span>
          <VIcon icon="arrowLeft" />
        </VBtn>
      </template>
    </VToolbar>
  </VAppBar>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { VAppBar, VToolbar, VBtn, VIcon } from 'vuetify/components'

const route = useRoute()
const router = useRouter()

const pageTitle = computed(() => (route.meta.title ? route.meta.title : ''))

const pageHasBack = computed(() => route.meta.pageHasBack ?? false)

function onBack() {
  router.back()
}
</script>
